export const SpotterLogoOpen = ({ className, width, height }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="-170 241 128.3 31"
    enableBackground="new -170 241 128.3 31"
    xmlSpace="preserve"
    width={width}
    height={height}
    className={className}
  >
    <path
      fill="#304968"
      d="M-138.8,259.6h4.1c0,1.9,1.2,2.8,3.5,2.8c2.1,0,3-0.9,3-2.1c0-1.5-1.6-2.2-3.6-2.8c-2.9-1-6.6-2.3-6.6-6.7
	c0-4,3.3-6.1,6.7-6.1c3.6,0,7,2.1,7,6.7h-4.1c0-1.8-1-2.7-2.9-2.7c-1.7,0-2.7,0.9-2.7,2.1c0,1.5,1.4,2.2,3.3,2.9
	c3,1,6.9,2.2,6.9,6.6c0,4-3.2,6.1-7.1,6.1C-135.3,266.4-138.8,264.3-138.8,259.6z"
    />
    <path
      fill="#304968"
      d="M-105.8,258.6c0,4.4-3.2,7.9-7.2,7.9c-2.1,0-3.8-0.8-4.8-2.2v7.7h-3.8v-20.8h3.8v1.7c1-1.3,2.7-2.2,4.8-2.2
	C-109,250.7-105.8,254.2-105.8,258.6z M-109.6,258.6c0-2.5-1.8-4.2-4.1-4.2c-2.3,0-4,1.6-4.1,3.9v0.5c0.1,2.4,1.8,3.9,4.1,3.9
	C-111.4,262.8-109.6,261.1-109.6,258.6z"
    />
    <path
      fill="#304968"
      d="M-103.9,258.6c0-4.4,3.5-7.9,7.8-7.9s7.8,3.4,7.8,7.9c0,4.4-3.5,7.9-7.8,7.9S-103.9,263-103.9,258.6z
	 M-92.1,258.6c0-2.4-1.8-4.1-4.1-4.1c-2.3,0-4,1.7-4,4.1c0,2.4,1.8,4.1,4,4.1C-93.8,262.7-92.1,261-92.1,258.6z"
    />
    <path
      fill="#304968"
      d="M-78.2,255.2h-2.6v11.2h-3.8v-11.2h-2.6v-3.7h2.6v-4.7h3.8v4.7h2.6V255.2z"
    />
    <path
      fill="#304968"
      d="M-68.3,255.2h-2.6v11.2h-3.8v-11.2h-2.6v-3.7h2.6v-4.7h3.8v4.7h2.6V255.2z"
    />
    <path
      fill="#304968"
      d="M-59.3,263.3c1.3,0,2.6-0.7,3-1.5h3.8c-0.9,3-3.5,4.7-6.9,4.7c-4.8,0-8-3.4-8-7.9c0-4.4,3.2-7.9,7.8-7.9
	c4.3,0,7.4,3.5,7.4,7.9c0,0.6,0,1-0.1,1.6h-11C-62.8,262.3-61.2,263.3-59.3,263.3z M-55.9,257.2c-0.4-2.2-2-3-3.6-3
	c-2.1,0-3.4,1.1-3.9,3H-55.9z"
    />
    <path
      fill="#304968"
      d="M-41.7,251.4v4.3c-2-0.2-4.1,0.7-4.1,3.6v7.3h-3.8v-14.9h3.8v2.2C-45,252.1-43.4,251.4-41.7,251.4z"
    />
    <path
      fill="#304968"
      d="M-161.3,246c-3.3,1.3-5.7,4.5-5.7,8.4c0,5,4,9,8.9,9c4.9,0,8.9-4,8.9-9c0-1.6-0.4-3-1-4.2l2.8-1.1
	c0.8,1.6,1.3,3.4,1.3,5.3c0,6.6-5.4,12-11.9,12c-6.6,0-11.9-5.4-11.9-12c0-5.1,3.2-9.4,7.6-11.2"
    />
    <path
      fill="#EE9E2C"
      d="M-155.8,256.1c0,1.9-1.5,3.6-3.5,3.6c-1.9,0-3.5-1.6-3.5-3.6c0-1.9,1.5-3.6,3.5-3.6
	C-157.4,252.5-155.8,254.1-155.8,256.1z"
    />
    <path
      fill="#EE9E2C"
      d="M-155.6,250.3c0,0.7-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.4,1.4-1.4
	C-156.1,248.9-155.6,249.5-155.6,250.3z"
    />
    <path
      fill="#EE9E2C"
      d="M-147.7,247.2c-2.1-5.2-8.1-7.6-13.3-5.4l0.7,1.7c2.1-0.9,4.3-0.9,6.3,0c2,0.8,3.6,2.4,4.5,4.4L-147.7,247.2
	z"
    />
    <path
      fill="#EE9E2C"
      d="M-159.8,245.2l0.7,1.7c2.4-1,5.1,0.1,6,2.4l1.7-0.7C-152.6,245.3-156.4,243.8-159.8,245.2
	C-159.7,245.2-159.7,245.2-159.8,245.2z"
    />
  </svg>
)
